import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';

export function getLaunchOptionsSync() {
  const retStr = MacleJSBridge.invokeSync(
    APINames.Native.GET_LAUNCH_OPTIONS_SYNC
  );
  return retStr && JSON.parse(retStr);
}
